/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { EuiFlexGroup, EuiFlexItem, EuiLink } from '@elastic/eui'

import type { FunctionComponent } from 'react'

type Props = {
  userId: string
}

const UserAuditLogLink: FunctionComponent<Props> = ({ userId }) => (
  <EuiFlexGroup gutterSize='s' alignItems='center' responsive={false}>
    <EuiFlexItem grow={false}>
      <EuiLink href={getDashboardHref(userId)} target='_blank'>
        <FormattedMessage
          id='user-audit-log-link.dashboard-label'
          defaultMessage='Audit logs for API and User Console actions'
        />
      </EuiLink>
    </EuiFlexItem>
    <EuiFlexItem grow={false}>
      <EuiLink href='https://ela.st/cloud-console-audit-logs' target='_blank' external={false}>
        <FormattedMessage id='user-audit-log-link.details-label' defaultMessage='(Details)' />
      </EuiLink>
    </EuiFlexItem>
  </EuiFlexGroup>
)

function getDashboardHref(userId: string) {
  return `https://platform-logging.kb.us-east-1.aws.found.io/app/discover#/?_g=(time:(from:now-24h,to:now))&_a=(columns:!(request_method,request_url,status_code,request_length,response_length,response_time),filters:!(),index:'service-iam-*,service-adminconsole-*',query:(language:lucene,query:'auth_user:${userId}'),sort:!(!('@timestamp',desc)))`
}

export default UserAuditLogLink
